import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Subject, ReplaySubject, Observable, of, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SystemInformationService {
  private envSettings: models.SystemInformationVM;
  public envSettingsBS: BehaviorSubject<models.SystemInformationVM | null>;
  constructor(private http: HttpClient) {
    this.envSettingsBS = new BehaviorSubject(null);
  }



  loadCurrentSystemInformation(){
    return this.http.get<models.SystemInformationVM>('api/SystemInformation/LoadEnviromentSettings'
    ).pipe(
      tap(res => {
        this.envSettings = res;
        this.envSettingsBS.next(this.envSettings);
      }),
      catchError(this.handleError<models.SystemInformationVM>('loadCurrentSystemInformation', ))
     );
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
